import * as Yup from 'yup';

import { MAX_FILE_SIZE_1MB } from '@/common/constants';

export const inspectorPersonSchema = () => {
    return (
        Yup.object({
            type: Yup.string()
                .trim()
                .required('Type is required'),
            name: Yup.string()
                .trim()
                .required('Name is required'),
            country: Yup.string()
                .trim()
                .required('Country is required'),
            category: Yup.string()
                .trim()
                .required('At least one category is required'),
            idNumber: Yup.string()
                .trim(),
            uploadIDCard: Yup.mixed()
                .nullable()
                .test('fileSize', 'File size is too large', (value) => {
                    if (value && (value as File).size > MAX_FILE_SIZE_1MB) {
                        return false;
                    }
                    return true;
                })
        }));
}